import { compose, mdsWidget } from 'dojo/_base/declare';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import { VAMclassNames } from "../_loadingHelpers/VAM";
import TempInvoiceEditor from './TempInvoiceEditor';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import { ExistingMusicianPlanningResponse, TempInvoiceFinderProject, TempInvoicePresetData } from "./TempInvoiceTypes";
import { TranslationHelpers } from "../../more/Helpers";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import { GenericDialogTypes } from "../../moreCore/UI/GenericDialog/GenericDialogTypes";
import TempInvoiceView from './TempInvoiceView';

class TempInvoiceProjectView extends compose(_EntityViewMixin<any>) {
    //templateString = template;
    private project: TempInvoiceFinderProject;

    private rowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_associate.gDisp_Name_Firstname",
            "ref_functional_group.description",
            "is_substitute_confirmed"
        ],
        colNamesInternal: [
            "ref_associate.gDisp_Name_Firstname",
            "ref_functional_group.description",
            "is_substitute_confirmed"
        ],
        headings: [
            "Name",
            "Funktiongruppe",
            TranslationHelpers.tryTranslate("TempInvoice_Label_IsSubstituteConfirmed")
        ]
    };

    private tableLayout: StaticTable.Layout = {
        name: "musicianPlanningTable",
        label: "musicianPlanningTable",
        rows: [(this as any).rowConfig]
    }

    private musicianPlanningTable: MdsLax<InstanceType<typeof StaticTable>>;
    private musicianPlanningStore: MdsLax<InstanceType<typeof EntityStore<ExistingMusicianPlanningResponse>>>;

    private setupTable() {
        this.musicianPlanningTable = new StaticTable();
        this.musicianPlanningTable.setLayout(this.tableLayout);
        this.musicianPlanningTable.setRowClick(lang.hitch(this, this._onClickRow));
        this.musicianPlanningTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEdit), lang.hitch(this, this._isEditAllowed));
        this.musicianPlanningTable.addCustomRowActionButton("customDelete", lang.hitch(this, this._onClickDelete), "fas fa-trash warningTXT", "", 9999999, null, lang.hitch(this, this._isEditAllowed));
        this.musicianPlanningTable.addCustomRowActionButton("confirm", lang.hitch(this, this._onClickConfirm), "fas fa-check successTXT", "", null, null, lang.hitch(this, this._isConfirmAllowed));
        this.musicianPlanningTable.addCustomRowActionButton("cancel", lang.hitch(this, this._onClickCancel), "fas fa-times primaryTXT", "", null, null, lang.hitch(this, this._isConfirmAllowed));
        this.musicianPlanningTable.setupFromStore(this.musicianPlanningStore);
        this.addContent(this.musicianPlanningTable.domNode);
    }
   
    /**
     * 
     * @param entityId
     * @param label
     * @param additionalParams
     * @param tabContainerName
     * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
     */
    setup(entityId: string,
        label: string,
        entity: TempInvoiceFinderProject,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string,

    ) {

        //this.entity = entity;
        this.project = entity;
        this.tabContainerName = tabContainerName;


        if (contextName) this.setContextName(contextName);

        this.showAsDlg(entityId, label, tabContainerName);
    }

    _afterLoaded() {
        let musicianPlannings = this.entity.musicianPlanning;

        //this.editingAllowed = this._isEditAllowed();
        //if (!this._isEditAllowed()) this.removeButton("edit");


        let editAllowed = this._isEditAllowed();
        this.addButton("new", "General_Label_New", lang.hitch(this, this.onRequestEditor), null, "primaryBG", "fas fa-plus-circle", true, "last", editAllowed);

        //this.createDefaultButton("new", lang.hitch(this, this.onRequestEditor), this.editingAllowed);

        this.musicianPlanningStore.setup(musicianPlannings);

        this.setupTable();
    }

    private _isEditAllowed(entity?: ExistingMusicianPlanningResponse) {
        let dateTo = new Date(this.entity.project.date_to);
        let musicianPlannings = this.entity.musicianPlanning;
        let maxDaysAfterEnd = this.entity.maxDaysAfterEnd;
        let isSubstituteConfirmed =  entity ? entity?.is_substitute_confirmed : false;

        if (dateTo && !isSubstituteConfirmed) {
            dateTo.setDate(dateTo.getDate() + maxDaysAfterEnd);
            dateTo.setHours(0, 0, 0, 0);

            let today = new Date(Date.now());
            today.setHours(0, 0, 0, 0);


            let editAllowed = today <= dateTo;
            return editAllowed;
        } else {
            return false;
        }
    }

    private _isConfirmAllowed(entity: ExistingMusicianPlanningResponse): boolean {
        return entity ? !entity?.is_substitute_confirmed : false;
    }

    private _onClickConfirm(rowGroup: StaticTable.StaticTableRowGroup<ExistingMusicianPlanningResponse>) {
        let dlg = new GenericDialog();
        dlg.setup({
            buttonPreset: "yesno",
            content: "TempInvoiceEditor_Message_ConfirmTemp",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            header: "TempInvoiceEditor_Header_ConfirmTemp",
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendConfirmRequest, rowGroup.entity)
            }
        });
    }

    private _sendConfirmRequest(entity: ExistingMusicianPlanningResponse) {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__TempInvoiceEditor_ConfirmMusicianPlanning", { entityID: entity.ID }, lang.hitch(this, this._onConfirmResponse), lang.hitch(this, this._onConfirmError));
    }

    private _onConfirmResponse(response: ExistingMusicianPlanningResponse) {
        this.StandbyStop();
        this.showToast({ title: "TempInvoice_Success_ConfirmMusicianPlanning", iconClass: "fas fa-check", timeout: 3000 });
        this.reload();
    }

    private _onConfirmError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.showToast({ title: "TempInvoice_Error_ConfirmMusicianPlanning", iconClass: "fas fa-exclamation-triangle", timeout: 3000 });
    }

    private _onClickCancel(rowGroup: StaticTable.StaticTableRowGroup<ExistingMusicianPlanningResponse>) {
        let dlg = new GenericDialog();
        dlg.setup({
            buttonPreset: "yesno",
            content: "TempInvoiceEditor_Message_CancelTemp",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            header: "TempInvoiceEditor_Header_CancelTemp",
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendCancelRequest, rowGroup.entity)
            }
        });
    }

    private _sendCancelRequest(entity: ExistingMusicianPlanningResponse) {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__TempInvoiceEditor_CancelMusicianPlanning", { entityID: entity.ID }, lang.hitch(this, this._onCancelResponse), lang.hitch(this, this._onCancelError));
    }

    private _onCancelResponse(response: ExistingMusicianPlanningResponse) {
        this.StandbyStop();
        this.showToast({ title: "TempInvoice_Success_CancelMusicianPlanning", iconClass: "fas fa-check", timeout: 3000 });
        this.reload();
    }

    private _onCancelError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.showToast({ title: "TempInvoice_Error_CancelMusicianPlanning", iconClass: "fas fa-exclamation-triangle", timeout: 3000 });
    }

    private _onClickEdit(rowGroup: StaticTable.StaticTableRowGroup<ExistingMusicianPlanningResponse>) {
        let entity = rowGroup.entity;
        this.onRequestEditor(this.entityID, null, entity);
    }

    private _onClickRow(row: StaticTable.StaticTableRow<ExistingMusicianPlanningResponse>) {
        let entity = row.rowGroup.entity;
        let view = new TempInvoiceView();
        view.setup(entity.ID, entity.$Displayname, entity, { parent: this }, "tempInvoiceProjectView", this.tabContainerName);
        view.on("saved", lang.hitch(this, this._onMusicianPlanningViewSaved));
    }

    private _onMusicianPlanningViewSaved() {
        this.reload();
    }

    protected onRequestEditor(entityID: string, entity, musicianPlanning?): MdsLax<InstanceType<typeof _WidgetBaseSP>> {
        let editor = new TempInvoiceEditor();
        this.close();

        editor.setup(this.project, this.tabContainerName, musicianPlanning);
        editor.on("saved", lang.hitch(this, this._onEditorSaved));

        return editor;
    }

    private _onEditorSaved() {
        this.emit("saved");
    }

    private _onOpenAdjacentProjectEditor(data: { adjecentProject: TempInvoiceFinderProject, presetData: TempInvoicePresetData }) {
        setTimeout(lang.hitch(this, this._openAdjacentProjectEditor, data.adjecentProject, data.presetData), 30);
    }

    private _openAdjacentProjectEditor(adjecentProject: TempInvoiceFinderProject, presetData: TempInvoicePresetData) {
        let adjacentProjectEditor = new TempInvoiceEditor();
        adjacentProjectEditor.setPresetData(presetData);
        adjacentProjectEditor.setup(adjecentProject, this.getTabContainerName(), null);
    }

    private _onClickDelete(rowGroup: StaticTable.StaticTableRowGroup<ExistingMusicianPlanningResponse>) {
        let dlg = new GenericDialog();
        dlg.setup({
            buttonPreset: "yesno",
            content: "TempInvoiceEditor_Message_DeleteTemp",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            header: "TempInvoiceEditor_Header_DeleteTemp",
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendDeleteRequest, rowGroup.entity)
            }
        });
    }

    private _sendDeleteRequest(entity: ExistingMusicianPlanningResponse) {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__TempInvoiceEditor_DeleteData",
            { ID: entity.ID },
            lang.hitch(this, this._onDeleteResponse),
            lang.hitch(this, this._onDeleteErr)
        );
    }

    private _onDeleteResponse(response) {
        this.StandbyStop();
        this.reload();
    }

    private _onDeleteErr(error) {
        console.error(error);
    }

    postCreate(): void {

        this.config = {
            entityClassname: VAMclassNames.ev_projects,
            labelProperty: "$Displayname",
            entityClassPrintname: this.translate("General_Label_EvProject"),
            cloneOptions: null,
            deleteOptions: null
            //userroleEdit: null,
            //featurePathEdit: null,//"EvBooking/EvBookingEditor",
            //requestDataFunctionname:"Webtool_API_Appointments__GetEntityData"
            //requestDataFunctionname:"Webtool_API_Appointments__GetEntityData"
        }


        this.musicianPlanningStore = new EntityStore();
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TempInvoiceProjectView);